// /children/<studentId> (004 FR-019–FR-026).
import { EditChildScreen } from "@/profile/children/EditChildScreen";

export default function EditChild() {
  return <EditChildScreen />;
}
